<template>
  <div>
    <div class="border-b border-gray-200 dark:border-hero-purple">
      <div
        class="pt-12 px-4 pb-6 md:py-12"
        style="max-width: 1200px; margin: 0 auto"
      >
        <!--bar 1 -->
        <div v-if="progressCount == 1">
          <div class="progressContainer progressBorder">
            <div
              class="progressbarNew progressBorder"
              style="width: 14.28%"
              tabindex="0"
              role="progressbar"
              aria-valuenow="14.28"
              aria-valuemin="0"
              aria-valuetext="Step 1 of 7 "
              aria-valuemax="100"
            >
              <p class="barTextNew"></p>
            </div>
          </div>
          <div class="" style="text-align: center">
            <p class="font-bold text-xs mt-2 dark:text-white">
              Step {{ progressCount }} of {{ totalViewCount }}
            </p>
          </div>
        </div>

        <!--bar 2 -->
        <div v-if="progressCount == 2">
          <div class="progressContainer progressBorder">
            <div
              class="progressbarNew progressBorder"
              style="width: 28.57%"
              tabindex="0"
              role="progressbar"
              aria-valuenow="28.57"
              aria-valuemin="0"
              aria-valuetext="Step 2 of 7 "
              aria-valuemax="100"
            ></div>
          </div>
          <div class="" style="text-align: center">
            <p class="font-bold text-xs mt-2 dark:text-white">
              Step {{ progressCount }} of {{ totalViewCount }}
            </p>
          </div>
        </div>

        <!--bar 3 -->
        <div v-if="progressCount == 3">
          <div class="progressContainer progressBorder">
            <div
              class="progressbarNew progressBorder"
              style="width: 42.85%"
              tabindex="0"
              role="progressbar"
              aria-valuenow="42.85"
              aria-valuemin="0"
              aria-valuetext="Step 3 of 7 "
              aria-valuemax="100"
            ></div>
          </div>
          <div class="" style="text-align: center">
            <p class="font-bold text-xs mt-2 dark:text-white">
              Step {{ progressCount }} of {{ totalViewCount }}
            </p>
          </div>
        </div>

        <!--bar 4 -->
        <div v-if="progressCount == 4">
          <div class="progressContainer progressBorder">
            <div
              class="progressbarNew progressBorder"
              style="width: 57.14%"
              tabindex="0"
              role="progressbar"
              aria-valuenow="57.14"
              aria-valuemin="0"
              aria-valuetext="Step 4 of 7 "
              aria-valuemax="100"
            ></div>
          </div>
          <div class="" style="text-align: center">
            <p class="font-bold text-xs mt-2 dark:text-white">
              Step {{ progressCount }} of {{ totalViewCount }}
            </p>
          </div>
        </div>

        <!--bar 5 -->
        <div v-if="progressCount == 5">
          <div class="progressContainer progressBorder">
            <div
              class="progressbarNew progressBorder"
              style="width: 71.42%"
              tabindex="0"
              role="progressbar"
              aria-valuenow="71.42"
              aria-valuemin="0"
              aria-valuetext="Step 5 of 7 "
              aria-valuemax="100"
            ></div>
          </div>
          <div class="" style="text-align: center">
            <p class="font-bold text-xs mt-2 dark:text-white">
              Step {{ progressCount }} of {{ totalViewCount }}
            </p>
          </div>
        </div>

        <!--bar 6 -->
        <div v-if="progressCount == 6">
          <div class="progressContainer progressBorder">
            <div
              class="progressbarNew progressBorder"
              style="width: 85.71%"
              tabindex="0"
              role="progressbar"
              aria-valuenow="85.71"
              aria-valuemin="0"
              aria-valuetext="Step 6 of 7 "
              aria-valuemax="100"
            ></div>
          </div>
          <div class="" style="text-align: center">
            <p class="font-bold text-xs mt-2 dark:text-white">
              Step {{ progressCount }} of {{ totalViewCount }}
            </p>
          </div>
        </div>

        <!--bar 7  -->
        <div v-if="progressCount == 7">
          <div class="progressContainer progressBorder">
            <div
              class="progressbarNew progressBorder"
              style="width: 100%"
              tabindex="0"
              role="progressbar"
              aria-valuenow="100"
              aria-valuemin="0"
              aria-valuetext="Step 7 of 7 "
              aria-valuemax="100"
            >
              
            </div>
          </div>
          <div class="" style="text-align: center">
            <p class="font-bold text-xs mt-2">
              Step {{ progressCount }} of {{ totalViewCount }}
            </p>
          </div>
        </div>

        <!--bar 8 
        <div v-if="progressCount == 8">
          <div class="progressContainer progressBorder">
            <div
              class="progressbarNew progressBorder"
              style="width: 100%"
              tabindex="0"
              role="progressbar"
              aria-valuenow="100"
              aria-valuemin="0"
              aria-valuetext="Step 8 of 8 "
              aria-valuemax="100"
            >
              
            </div>
          </div>
          <div class="" style="text-align: center">
            <p class="font-bold text-xs mt-2">
              Step {{ progressCount }} of {{ totalViewCount }}
            </p>
          </div>
          
        </div>
        -->
      </div>
    </div>

    <!--

    <div class="progressBar">
      <div v-if="progressCount == 1">
        <div
          class="bar1"
          tabindex="0"
          role="progressbar"
          aria-valuenow="12.5"
          aria-valuemin="0"
          aria-valuetext="Step 1 of 8 "
          aria-valuemax="100"
        >
          <p class="bar-text">
            Step {{ progressCount }} of {{ totalViewCount }}
          </p>
        </div>
        <div class="">
          <p class="font-bold text-xs mt-2">
            Step {{ progressCount }} of {{ totalViewCount }}
          </p>
        </div>
      </div>
      <div v-if="progressCount == 2">
        <div
          class="bar2"
          tabindex="0"
          role="progressbar"
          aria-valuenow="25"
          aria-valuemin="0"
          aria-valuetext="Step 2 of 8 "
          aria-valuemax="100"
        >
          <p class="bar-text">
            Step {{ progressCount }} of {{ totalViewCount }}
          </p>
        </div>
        <div class="">
          <p class="font-bold text-xs mt-2">
            Step {{ progressCount }} of {{ totalViewCount }}
          </p>
        </div>
      </div>
      <div v-if="progressCount == 3">
        <div
          class="bar3"
          tabindex="0"
          role="progressbar"
          aria-valuenow="37.5"
          aria-valuemin="0"
          aria-valuetext="Step 3 of 8 "
          aria-valuemax="100"
        >
          <p class="bar-text">
            Step {{ progressCount }} of {{ totalViewCount }}
          </p>
        </div>
        <div class="">
          <p class="font-bold text-xs mt-2">
            Step {{ progressCount }} of {{ totalViewCount }}
          </p>
        </div>
      </div>
      <div v-if="progressCount == 4">
        <div
          class="bar4"
          tabindex="0"
          role="progressbar"
          aria-valuenow="50"
          aria-valuemin="0"
          aria-valuetext="Step 4 of 8 "
          aria-valuemax="100"
        >
          <p class="bar-text">
            Step {{ progressCount }} of {{ totalViewCount }}
          </p>
        </div>
        <div class="">
          <p class="font-bold text-xs mt-2">
            Step {{ progressCount }} of {{ totalViewCount }}
          </p>
        </div>
      </div>
      <div v-if="progressCount == 5">
        <div
          class="bar5"
          tabindex="0"
          role="progressbar"
          aria-valuenow="67.5"
          aria-valuemin="0"
          aria-valuetext="Step 5 of 8 "
          aria-valuemax="100"
        >
          <p class="bar-text">
            Step {{ progressCount }} of {{ totalViewCount }}
          </p>
        </div>
        <div class="">
          <p class="font-bold text-xs mt-2">
            Step {{ progressCount }} of {{ totalViewCount }}
          </p>
        </div>
      </div>
      <div v-if="progressCount == 6">
        <div
          class="bar6"
          tabindex="0"
          role="progressbar"
          aria-valuenow="75"
          aria-valuemin="0"
          aria-valuetext="Step 6 of 8 "
          aria-valuemax="100"
        >
          <p class="bar-text">
            Step {{ progressCount }} of {{ totalViewCount }}
          </p>
        </div>
        <div class="">
          <p class="font-bold text-xs mt-2">
            Step {{ progressCount }} of {{ totalViewCount }}
          </p>
        </div>
      </div>
      <div
        v-if="progressCount == 7"
        role="progressbar"
        tabindex="0"
        aria-valuenow="87.5"
        aria-valuemin="0"
        aria-valuetext="Step 7 of 8 "
        aria-valuemax="100"
      >
        <div class="bar7">
          <p class="bar-text">
            Step {{ progressCount }} of {{ totalViewCount }}
          </p>
        </div>
        <div class="">
          <p class="font-bold text-xs mt-2">
            Step {{ progressCount }} of {{ totalViewCount }}
          </p>
        </div>
      </div>
      <div
        v-if="progressCount == 8"
        role="progressbar"
        tabindex="0"
        aria-valuenow="100"
        aria-valuemin="0"
        aria-valuetext="Step 8 of 8 "
        aria-valuemax="100"
      >
        <div class="bar8">
          <p class="bar-text">
            Step {{ progressCount }} of {{ totalViewCount }}
          </p>
        </div>
        <div class="">
          <p class="font-bold text-xs mt-2">
            Step {{ progressCount }} of {{ totalViewCount }}
          </p>
        </div>
      </div>
     
      <div v-if="progressCount == 9">
        <div class="bar9">
          <p class="bar-text">
            Step {{ progressCount }} of {{ totalViewCount }}
          </p>
        </div>
        <div class="">
          <p class="font-bold text-xs mt-2">
            Step {{ progressCount }} of {{ totalViewCount }}
          </p>
        </div>
      </div>
    
      
    </div>
     -->
  </div>
</template>

<script>
export default {
  name: "ProgressBar",

  data() {
    return {};
  },
  computed: {
    progressCount() {
      return this.$store.state.progress;
    },
    totalViewCount() {
      return this.$store.state.questionsCount;
    },
  },
};
</script>

<style lang="css" scoped></style>
